
'use client';

import { Button } from '@/components/ui/button';
import { FileQuestion, PhoneCall, Home } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted/30">
      <Card className="max-w-md w-full shadow-xl">
        <CardHeader className="text-center">
          <div className="mx-auto bg-muted w-16 h-16 rounded-full flex items-center justify-center mb-4">
            <FileQuestion className="h-10 w-10 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl font-bold">Página Não Encontrada</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground">
            O endereço que você tentou acessar não existe ou foi movido.
          </p>
          <div className="p-4 bg-primary/5 rounded-lg border border-dashed border-primary/30">
            <p className="text-sm font-medium">
              Se você acredita que isso é um erro, contate <strong>Guilherme Noster</strong>.
            </p>
          </div>
        </CardContent>
        <CardFooter>
          <Button asChild className="w-full">
            <Link href="/dashboard">
                <Home className="mr-2 h-4 w-4" />
                Voltar para o Início
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
